'use strict';


import TWER_UPLOADS from './modules/uploads';
import TWER_CONTROLS from './modules/controls';
//import TWER_CUSTOM_FIELDS from './modules/custom-fields';

jQuery(document).ready(function($) {
  new TWER_UPLOADS($);
  new TWER_CONTROLS($);
  //new TWER_CUSTOM_FIELDS($);
});


var tp = '';
var map;
var geo;
var marker;

jQuery.noConflict();

const pickerMapApply = (toggleElementIds, pickerIds, colorsIds, sizeIds) => {
  for (let i = 0; i < toggleElementIds.length; i++) {
    const showIcon = document.getElementById(toggleElementIds[i]);
    const style = document.getElementById('marker_style');
    const markerBalloon = document.getElementsByClassName('marker-balloon__dot');
    const markerDot = document.getElementsByClassName('marker--dot-solid');
    let currentMarkerId = '';

    if (markerBalloon.length > 0 && 'balloon-default' === style.value) {
      currentMarkerId = 'treweler-picker';
    }
    if (markerDot.length > 0 && 'dot-default' === style.value) {
      currentMarkerId = 'treweler-picker-dot';
    }

    if (currentMarkerId !== showIcon.id) continue;

    const icon = document.getElementById(pickerIds[i]).value;
    const color = document.getElementById(colorsIds[i]).value;
    const size = Number.isNaN(parseFloat(document.getElementById(sizeIds[i]).value)) ? 15 : parseFloat(document.getElementById(sizeIds[i]).value);

    if (showIcon.checked) {
      if (markerBalloon.length > 0) {
        if (icon.length > 0) {
          markerBalloon[0].innerHTML = `<span class="marker-balloon__icon material-icons" style="color:${color};font-size:${size}px;">${icon}</span>`;
        } else {
          markerBalloon[0].innerHTML = '';
        }
      }

      if (markerDot.length > 0) {
        if (icon.length > 0) {
          markerDot[0].innerHTML = `<span class="marker-dot__icon material-icons" style="color:${color};font-size:${size}px;">${icon}</span>`;
        } else {
          markerDot[0].innerHTML = '';
        }
      }
    } else {
      if (markerBalloon.length > 0) {
        markerBalloon[0].innerHTML = '';
      }

      if (markerDot.length > 0) {
        markerDot[0].innerHTML = '';
      }
    }

  }
};

(function($) {
  $(function() {

    const markerStyle = $('#marker_style');
    const markerStyleVal = markerStyle.val();
    const colorPicker = $('.color-picker');
    const markerPosition = $('#marker_position').val().replace(/_/g, '-');
    const markerSize = $('#treweler-marker-img-size').val();

    /**
     * Get mapbox token
     */
    function getToken() {
      if (tp.length === 0) {
        jQuery.ajax({
          url: twer_ajax.url,
          type: 'GET',
          data: {action: 'treweler_get_admin_token'},
          success: function(response) {
            try {
              const res = atob(response).replace('###', '');
              tp = res.replace('###', '');
            } catch (e) {

              tp = twer_ajax.api_key;
            }
            init_map();
          }
        });
      }
    }

    function hex2rgba(hex, opacity) {
      opacity = parseFloat(opacity);
      hex = hex.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      return `rgba(${r},${g},${b},${opacity})`;
    }

    /**
     * Initialize map
     * MarkerIcon 1
     */
    function init_map() {

      $('.twer-root').each(function() {
        $(this).find('[data-toggle="tooltip"]').tooltip({
          container: $(this).closest('.twer-root')
        });
      });

      $('#marker_map').html('');
      if (tp.length !== 0) {

        let lat = (($('#latitude').val().trim() !== '' && $('#latitude').val() !== 0) ? $('#latitude').val().trim() : 0.1),
          lng = (($('#longitude').val().trim() !== '' && $('#longitude').val() !== 0) ? $('#longitude').val().trim() : 0.1),
          zoom = ($('#setZoom').val().trim() !== '' ? $('#setZoom').val() : 0),
          map_style = ($('#map_id').val().trim() !== '' ? $('#map_id option:selected').attr('data-map_style') : 'mapbox://styles/mapbox/streets-v11'),
          color = $('#markerColor').val(),
          halo_opacity = Number.isNaN(parseFloat($('#treweler-marker-halo-opacity').val())) ? 0.5 : parseFloat($('#treweler-marker-halo-opacity').val()),
          halo_color = hex2rgba($('#marker_halo_color').val(), halo_opacity),
          markerInnerSize = Number.isNaN(parseFloat($('#treweler-marker-size').val())) ? 12 : parseFloat($('#treweler-marker-size').val()),

          marker_dotcenter_color = hex2rgba($('#marker_dotcenter_color').val(), 1),

          borderColor = hex2rgba($('#marker_border_color').val(), 1),
          borderWidth = Number.isNaN(parseFloat($('#treweler-marker-border-width').val())) ? 0 : parseFloat($('#treweler-marker-border-width').val()),
          markerInnerSizeMargins = ((markerInnerSize + borderWidth + borderWidth) / 2) * -1,

          cornerRadius = Number.isNaN(parseFloat($('#treweler-marker-corner-radius-group').val())) ? 50 : parseFloat($('#treweler-marker-corner-radius-group').val()),
          cornerRadiusUnits = Number.isNaN($('#treweler-marker-corner-radius-group-select').val()) ? '%' : $('#treweler-marker-corner-radius-group-select').val(),

          markerColorBalloon = hex2rgba($('#marker_color_balloon').val(), 1),
          markerSizeBalloon = Number.isNaN(parseFloat($('#treweler-marker-size-balloon').val())) ? 18 : parseFloat($('#treweler-marker-size-balloon').val()),
          borderColorBalloon = hex2rgba($('#marker_border_color_balloon').val(), 1),
          borderWidthBalloon = Number.isNaN(parseFloat($('#treweler-marker-border-width-balloon').val())) ? 4 : parseFloat($('#treweler-marker-border-width-balloon').val()),
          dotColor = hex2rgba($('#marker_dot_color').val(), 1),
          dotSize = Number.isNaN(parseFloat($('#treweler-marker-dot-size').val())) ? 8 : parseFloat($('#treweler-marker-dot-size').val()),

          markerColorTriangle = hex2rgba($('#marker_color_triangle').val(), 1),
          markerWidthTriangle = Number.isNaN(parseFloat($('#treweler-marker-width-triangle').val())) ? 12 : parseFloat($('#treweler-marker-width-triangle').val()),
          markerHeightTriangle = Number.isNaN(parseFloat($('#treweler-marker-height-triangle').val())) ? 10 : parseFloat($('#treweler-marker-height-triangle').val());

        TWER_MAPBOX.mapboxgl.accessToken = tp;
        map = new TWER_MAPBOX.mapboxgl.Map({
          container: 'marker_map',
          style: map_style,
          center: [lng, lat],
          zoom: zoom,
          minZoom: 0,
          maxZoom: 24
        });

        /**
         * Mapbox Geocoder
         */
        let geocoder = new TWER_MAPBOX.MapboxGeocoder({
          accessToken: TWER_MAPBOX.mapboxgl.accessToken,
          mapboxgl: TWER_MAPBOX.mapboxgl,
          marker: false
        });

        geocoder.on('result', function(e) {

          $('#latitude').val(e.result.center[1]);
          $('#longitude').val(e.result.center[0]);

          setTimeout(function() {
            addHTMLMarker();
          }, 200);

        });

        map.addControl(geocoder);

        if ($('#marker_style').val() !== 'custom') {

          var markerEle = document.createElement('div');
          let defaultAnchor = markerPosition;

          markerEle.className = 'treweler-marker';
          if (markerStyleVal === 'default') {
            markerEle.innerHTML = '<div class="marker"><div class="marker-wrap"><div class="marker__shadow" style="background-color:' + halo_color + ';"><div class="marker__border" style="border-color:' + color + ';"><div class="marker__center"></div></div></div></div></div>';
          } else if ('dot-default' === markerStyleVal) {
            markerEle.innerHTML = `<div class="marker marker--dot-solid" style="margin-left:${markerInnerSizeMargins}px;margin-top:${markerInnerSizeMargins}px;border:${borderWidth}px solid ${borderColor};border-radius: ${cornerRadius}${cornerRadiusUnits};width:${markerInnerSize}px;height:${markerInnerSize}px;background-color:${marker_dotcenter_color};"></div>`;
            defaultAnchor = 'center';
          } else if ('balloon-default' === markerStyleVal) {
            let styleBalloon = `
                        background-color: ${markerColorBalloon};    
                        border: ${borderWidthBalloon}px solid ${borderColorBalloon};
                        width: ${markerSizeBalloon}px;
                        height: ${markerSizeBalloon}px;`;

            let styleBalloonDot = `
                        width:${dotSize}px;
                        height:${dotSize}px;
                        margin-left:${(dotSize / 2) * -1}px;
                        margin-top:${(dotSize / 2) * -1}px;
                        background-color:${dotColor};
                        `;
            markerEle.innerHTML = `<div class="treweler-marker marker-balloon" style="${styleBalloon}"><div class="marker-balloon__dot" style="${styleBalloonDot}"></div></div>`;

            defaultAnchor = 'bottom';

          } else if ('triangle-default' === markerStyleVal) {
            const styleTriangle = `
                        
                        border-right-width:${markerWidthTriangle / 2}px;
                        border-left-width:${markerWidthTriangle / 2}px;
                        border-bottom-width: ${markerHeightTriangle}px;
                        border-bottom-color: ${markerColorTriangle};
                        
                        `;
            markerEle.innerHTML = `<div class="treweler-marker marker-triangle" style="${styleTriangle}"></div>`;

            defaultAnchor = 'center';
          }

          marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
            draggable: true,
            anchor: defaultAnchor
          }).setLngLat([lng, lat]).addTo(map);

          if ('balloon-default' === markerStyleVal) {
            const $marker = document.getElementsByClassName('marker-balloon')[0];
            const rotateHeight = $marker.getBoundingClientRect().height;
            const rotateMarkerSizeBalloon = Number.isNaN(parseFloat($('#treweler-marker-size-balloon').val())) ? 18 : parseFloat($('#treweler-marker-size-balloon').val());
            const rotateBorderWidthBalloon = Number.isNaN(parseFloat($('#treweler-marker-border-width-balloon').val())) ? 4 : parseFloat($('#treweler-marker-border-width-balloon').val());
            $('.marker-balloon').css('bottom', ((rotateHeight - (rotateMarkerSizeBalloon + rotateBorderWidthBalloon + rotateBorderWidthBalloon)) / 2));
          }
        } else {

          let imgURL = $('#thumbnail_id').closest('.js-twer-attach-wrap').find('img').length > 0 ? $('#thumbnail_id').closest('.js-twer-attach-wrap').find('img').attr('src') : '',
            anchorV = $('#marker_position').val().replace(/_/g, '-'),
            imgSize = $('#marker_icon_size').val() != '' ? $('#marker_icon_size').val().split(';') : '42;42'.split(';');

          let iHeight = parseInt(imgSize[0]) <= 42 ? (parseInt(imgSize[0]) % 2 == 0 ? parseInt(imgSize[0]) : parseInt(imgSize[0]) + 1) : 42;
          let iWidth = parseInt(imgSize[1]) <= 42 ? (parseInt(imgSize[1]) % 2 == 0 ? parseInt(imgSize[1]) : parseInt(imgSize[1]) + 1) : 42;


          let markerSizeR = Number.isNaN(parseInt($('#treweler-marker-img-size').val())) ? 42 : parseInt($('#treweler-marker-img-size').val());

          var markerEle = document.createElement('div');
          markerEle.className = 'treweler-marker icon';
          if(imgURL) {
            markerEle.style.backgroundImage = 'url(' + imgURL + ')';
          }
          markerEle.style.backgroundSize = 'contain';
          markerEle.style.backgroundRepeat = 'no-repeat';
          markerEle.style.backgroundPosition = 'center center';
          markerEle.style.width = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : parseInt(iWidth) + 'px';
          markerEle.style.height = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : parseInt(iHeight) + 'px';
          marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
            draggable: true,
            anchor: anchorV
          }).setLngLat([lng, lat]).addTo(map);

        }

        /**
         * Change marker position on drag
         */
        marker.on('dragend', function(e) {
          let ll = marker.getLngLat();
          $('#latitude').val(ll.lat);
          $('#longitude').val(ll.lng);
        });

        /**
         * Change marker position on click
         */
        map.on('click', function(e) {
          marker.setLngLat([e.lngLat.lng, e.lngLat.lat]).addTo(map);
          $('#latitude').val(e.lngLat.lat);
          $('#longitude').val(e.lngLat.lng);
        });

        /**
         * Change zoom value
         */
        map.on('zoom', function(e) {
          let zoomV = map.getZoom().toFixed(2);
          $('#setZoom').val(zoomV);
        });

      } else {
        $('#marker_map').append('<p class="notice notice-error settings-error is-dismissible">Mapbox access token is required.</p>');
      }

      pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);

    }

    /**
     * Add HTML Marker
     */
    function addHTMLMarker() {
      let lat = (($('#latitude').val().trim() != '' && $('#latitude').val() != 0) ? $('#latitude').val().trim() : 0.1),
        lng = (($('#longitude').val().trim() != '' && $('#longitude').val() != 0) ? $('#longitude').val().trim() : 0.1),
        color = $('#markerColor').val(),
        markerStyleVal = $('#marker_style').val(),
        halo_opacity = Number.isNaN(parseFloat($('#treweler-marker-halo-opacity').val())) ? 0.5 : parseFloat($('#treweler-marker-halo-opacity').val()),
        halo_color = hex2rgba($('#marker_halo_color').val(), halo_opacity),
        markerInnerSize = Number.isNaN(parseFloat($('#treweler-marker-size').val())) ? 12 : parseFloat($('#treweler-marker-size').val()),
        borderColor = hex2rgba($('#marker_border_color').val(), 1),
        borderWidth = Number.isNaN(parseFloat($('#treweler-marker-border-width').val())) ? 0 : parseFloat($('#treweler-marker-border-width').val()),
        markerInnerSizeMargins = ((markerInnerSize + borderWidth + borderWidth) / 2) * -1,
        cornerRadius = Number.isNaN(parseFloat($('#treweler-marker-corner-radius-group').val())) ? 50 : parseFloat($('#treweler-marker-corner-radius-group').val()),
        marker_dotcenter_color = hex2rgba($('#marker_dotcenter_color').val(), 1),
        cornerRadiusUnits = Number.isNaN($('#treweler-marker-corner-radius-group-select').val()) ? '%' : $('#treweler-marker-corner-radius-group-select').val(),
        markerColorBalloon = hex2rgba($('#marker_color_balloon').val(), 1),
        markerSizeBalloon = Number.isNaN(parseFloat($('#treweler-marker-size-balloon').val())) ? 18 : parseFloat($('#treweler-marker-size-balloon').val()),
        borderColorBalloon = hex2rgba($('#marker_border_color_balloon').val(), 1),
        borderWidthBalloon = Number.isNaN(parseFloat($('#treweler-marker-border-width-balloon').val())) ? 4 : parseFloat($('#treweler-marker-border-width-balloon').val()),
        dotColor = hex2rgba($('#marker_dot_color').val(), 1),
        dotSize = Number.isNaN(parseFloat($('#treweler-marker-dot-size').val())) ? 8 : parseFloat($('#treweler-marker-dot-size').val()),
        markerColorTriangle = hex2rgba($('#marker_color_triangle').val(), 1),
        markerWidthTriangle = Number.isNaN(parseFloat($('#treweler-marker-width-triangle').val())) ? 12 : parseFloat($('#treweler-marker-width-triangle').val()),
        markerHeightTriangle = Number.isNaN(parseFloat($('#treweler-marker-height-triangle').val())) ? 10 : parseFloat($('#treweler-marker-height-triangle').val());

      let defaultAnchor = markerPosition;

      /* remove marker */
      marker.remove();

      /* Add Marker */
      /* MarkerIcon 2 */
      const markerEle = document.createElement('div');
      markerEle.className = 'treweler-marker';
      if ('default' === markerStyleVal) {
        markerEle.innerHTML = '<div class="marker"><div class="marker-wrap"><div class="marker__shadow" style="background-color:' + halo_color + ';"><div class="marker__border" style="border-color:' + color + ';"><div class="marker__center"></div></div></div></div></div>';
      } else if ('dot-default' === markerStyleVal) {
        markerEle.innerHTML = `<div class="marker marker--dot-solid" style="margin-left:${markerInnerSizeMargins}px;margin-top:${markerInnerSizeMargins}px;border:${borderWidth}px solid ${borderColor};border-radius: ${cornerRadius}${cornerRadiusUnits};width:${markerInnerSize}px;height:${markerInnerSize}px;background-color:${marker_dotcenter_color};"></div>`;
        defaultAnchor = 'center';
      } else if ('balloon-default' === markerStyleVal) {
        let styleBalloon = `
                        background-color: ${markerColorBalloon};    
                        border: ${borderWidthBalloon}px solid ${borderColorBalloon};
                        width: ${markerSizeBalloon}px;
                        height: ${markerSizeBalloon}px;`;
        let styleBalloonDot = `
                        width:${dotSize}px;
                        height:${dotSize}px;
                        margin-left:${(dotSize / 2) * -1}px;
                        margin-top:${(dotSize / 2) * -1}px;
                        background-color:${dotColor};
                        `;
        markerEle.innerHTML = `<div class="treweler-marker marker-balloon" style="${styleBalloon}"><div class="marker-balloon__dot" style="${styleBalloonDot}"></div></div>`;
        defaultAnchor = 'bottom';

      } else if ('triangle-default' === markerStyleVal) {
        const styleTriangle = `
                        
                        border-right-width:${markerWidthTriangle / 2}px;
                        border-left-width:${markerWidthTriangle / 2}px;
                        border-bottom-width: ${markerHeightTriangle}px;
                        border-bottom-color: ${markerColorTriangle};
                        
                        `;
        markerEle.innerHTML = `<div class="treweler-marker marker-triangle" style="${styleTriangle}"></div>`;

        defaultAnchor = 'center';
      }

      marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
        draggable: true,
        anchor: defaultAnchor
      }).setLngLat([lng, lat]).addTo(map);

      if ('balloon-default' === markerStyleVal) {
        const $marker = document.getElementsByClassName('marker-balloon')[0];
        const rotateHeight = $marker.getBoundingClientRect().height;
        const rotateMarkerSizeBalloon = Number.isNaN(parseFloat($('#treweler-marker-size-balloon').val())) ? 18 : parseFloat($('#treweler-marker-size-balloon').val());
        const rotateBorderWidthBalloon = Number.isNaN(parseFloat($('#treweler-marker-border-width-balloon').val())) ? 4 : parseFloat($('#treweler-marker-border-width-balloon').val());
        $('.marker-balloon').css('bottom', ((rotateHeight - (rotateMarkerSizeBalloon + rotateBorderWidthBalloon + rotateBorderWidthBalloon)) / 2));
      }

      /**
       * Change marker position on drag
       */
      marker.on('dragend', function(e) {
        let ll = marker.getLngLat();
        $('#latitude').val(ll.lat);
        $('#longitude').val(ll.lng);
      });
    }

    if ($('#marker_map').length) {

      setTimeout(function() {
        getToken();
      }, 1000);

      /**
       * On change of latlng value
       */
      $('#latitude, #longitude').on('input', function() {
        if ($('#latitude').val().trim() != '' && $('#longitude').val().trim() != '') {
          marker.setLngLat([$('#longitude').val(), $('#latitude').val()]).addTo(map);
          map.setCenter([$('#longitude').val(), $('#latitude').val()]);
        }
      });

      /**
       * On change of `map`, set `map` style
       */
      $('#map_id').on('input', function() {
        let styleV = ($('#map_id').val().trim() != '' ? $('#map_id option:selected').attr('data-map_style') : 'mapbox://styles/mapbox/streets-v11');
        map.setStyle(styleV);
      });

      /**
       * Change marker on change of style
       * MarkerIcon 3
       */
      markerStyle.on('change', function() {

        //if ($('.js-twer-attach-wrap input[type="hidden"]').val() >= 1) {
        //  return;
        //}

        let lat = (($('#latitude').val().trim() != '' && $('#latitude').val() != 0) ? $('#latitude').val().trim() : 0.1),
          lng = (($('#longitude').val().trim() != '' && $('#longitude').val() != 0) ? $('#longitude').val().trim() : 0.1),
          color = $('#markerColor').val(),
          halo_opacity = Number.isNaN(parseFloat($('#treweler-marker-halo-opacity').val())) ? 0.5 : parseFloat($('#treweler-marker-halo-opacity').val()),
          halo_color = hex2rgba($('#marker_halo_color').val(), halo_opacity),
          markerInnerSize = Number.isNaN(parseFloat($('#treweler-marker-size').val())) ? 12 : parseFloat($('#treweler-marker-size').val()),
          borderColor = hex2rgba($('#marker_border_color').val(), 1),
          borderWidth = Number.isNaN(parseFloat($('#treweler-marker-border-width').val())) ? 0 : parseFloat($('#treweler-marker-border-width').val()),
          markerInnerSizeMargins = ((markerInnerSize + borderWidth + borderWidth) / 2) * -1,
          marker_dotcenter_color = hex2rgba($('#marker_dotcenter_color').val(), 1),
          cornerRadius = Number.isNaN(parseFloat($('#treweler-marker-corner-radius-group').val())) ? 50 : parseFloat($('#treweler-marker-corner-radius-group').val()),
          cornerRadiusUnits = Number.isNaN($('#treweler-marker-corner-radius-group-select').val()) ? '%' : $('#treweler-marker-corner-radius-group-select').val(),
          markerColorBalloon = hex2rgba($('#marker_color_balloon').val(), 1),
          markerSizeBalloon = Number.isNaN(parseFloat($('#treweler-marker-size-balloon').val())) ? 18 : parseFloat($('#treweler-marker-size-balloon').val()),
          borderColorBalloon = hex2rgba($('#marker_border_color_balloon').val(), 1),
          borderWidthBalloon = Number.isNaN(parseFloat($('#treweler-marker-border-width-balloon').val())) ? 4 : parseFloat($('#treweler-marker-border-width-balloon').val()),
          dotColor = hex2rgba($('#marker_dot_color').val(), 1),
          dotSize = Number.isNaN(parseFloat($('#treweler-marker-dot-size').val())) ? 8 : parseFloat($('#treweler-marker-dot-size').val()),
          markerColorTriangle = hex2rgba($('#marker_color_triangle').val(), 1),
          markerWidthTriangle = Number.isNaN(parseFloat($('#treweler-marker-width-triangle').val())) ? 12 : parseFloat($('#treweler-marker-width-triangle').val()),
          markerHeightTriangle = Number.isNaN(parseFloat($('#treweler-marker-height-triangle').val())) ? 10 : parseFloat($('#treweler-marker-height-triangle').val());

        let defaultAnchor = markerPosition;

        marker.remove();
        var markerEle = document.createElement('div');
        let markerSelector = $(this).val();


        markerEle.className = 'treweler-marker';
        if (markerSelector === 'default') {
          markerEle.innerHTML = '<div class="marker"><div class="marker-wrap"><div class="marker__shadow" style="background-color:' + halo_color + ';"><div class="marker__border" style="border-color:' + color + ';"><div class="marker__center"></div></div></div></div></div>';
        } else if ('dot-default' === markerSelector) {
          markerEle.innerHTML = `<div class="marker marker--dot-solid" style="margin-left:${markerInnerSizeMargins}px;margin-top:${markerInnerSizeMargins}px;border:${borderWidth}px solid ${borderColor};border-radius: ${cornerRadius}${cornerRadiusUnits};width:${markerInnerSize}px;height:${markerInnerSize}px;background-color:${marker_dotcenter_color};"></div>`;
          defaultAnchor = 'center';
        } else if ('balloon-default' === markerSelector) {
          let styleBalloon = `
                        background-color: ${markerColorBalloon};    
                        border: ${borderWidthBalloon}px solid ${borderColorBalloon};
                        width: ${markerSizeBalloon}px;
                        height: ${markerSizeBalloon}px;`;

          let styleBalloonDot = `
                        width:${dotSize}px;
                        height:${dotSize}px;
                        margin-left:${(dotSize / 2) * -1}px;
                        margin-top:${(dotSize / 2) * -1}px;
                        background-color:${dotColor};
                        `;
          markerEle.innerHTML = `<div class="treweler-marker marker-balloon" style="${styleBalloon}"><div class="marker-balloon__dot" style="${styleBalloonDot}"></div></div>`;
          defaultAnchor = 'bottom';

        } else if ('triangle-default' === markerSelector) {
          const styleTriangle = `
                        
                        border-right-width:${markerWidthTriangle / 2}px;
                        border-left-width:${markerWidthTriangle / 2}px;
                        border-bottom-width: ${markerHeightTriangle}px;
                        border-bottom-color: ${markerColorTriangle};
                        
                        `;
          markerEle.innerHTML = `<div class="treweler-marker marker-triangle" style="${styleTriangle}"></div>`;

          defaultAnchor = 'center';
        }

        marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
          draggable: true,
          anchor: defaultAnchor
        }).setLngLat([lng, lat]).addTo(map);

        if ('balloon-default' === markerSelector) {
          const $marker = document.getElementsByClassName('marker-balloon')[0];
          const rotateHeight = $marker.getBoundingClientRect().height;
          const rotateMarkerSizeBalloon = Number.isNaN(parseFloat($('#treweler-marker-size-balloon').val())) ? 18 : parseFloat($('#treweler-marker-size-balloon').val());
          const rotateBorderWidthBalloon = Number.isNaN(parseFloat($('#treweler-marker-border-width-balloon').val())) ? 4 : parseFloat($('#treweler-marker-border-width-balloon').val());
          $('.marker-balloon').css('bottom', ((rotateHeight - (rotateMarkerSizeBalloon + rotateBorderWidthBalloon + rotateBorderWidthBalloon)) / 2));
        }

        marker.on('dragend', function(e) {
          let ll = marker.getLngLat();
          $('#latitude').val(ll.lat);
          $('#longitude').val(ll.lng);
        });

        /*----------------*/
        if (markerSelector === 'custom') {

          let selectedImg = {
            url: $('#thumbnail_id').closest('.js-twer-attach-wrap').find('img').attr('src')
          };

          if (selectedImg.url.length > 0) {
            let lat = (($('#latitude').val().trim() != '' && $('#latitude').val() != 0) ? $('#latitude').val().trim() : 0.1),
              lng = (($('#longitude').val().trim() != '' && $('#longitude').val() != 0) ? $('#longitude').val().trim() : 0.1),
              anchorV = $('#marker_position').val().replace(/_/g, '-');

            let iHeight = 42,
              iWidth = 42;

            let markerSizeR = Number.isNaN(parseInt($('#treweler-marker-img-size').val())) ? 42 : parseInt($('#treweler-marker-img-size').val());

            /* remove marker */
            marker.remove();
            /* add icon */
            var markerEle = document.createElement('div');
            markerEle.className = 'treweler-marker icon';
            markerEle.style.backgroundImage = 'url(' + selectedImg.url + ')';
            markerEle.style.backgroundSize = 'contain';
            markerEle.style.backgroundRepeat = 'no-repeat';
            markerEle.style.backgroundPosition = 'center center';
            markerEle.style.width = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : iWidth + 'px';
            markerEle.style.height = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : iHeight + 'px';

            marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
              draggable: true,
              anchor: anchorV
            }).setLngLat([lng, lat]).addTo(map);
            /**
             * Change marker position on drag
             */
            marker.on('dragend', function(e) {
              let ll = marker.getLngLat();
              $('#latitude').val(ll.lat);
              $('#longitude').val(ll.lng);
            });

            //$('#marker_icon_size').val(iHeight + ';' + iWidth);

          }

        }
        /*----------------*/

        pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
      });

      $(document).on('twer-attach-add', function(e, xmlFrame){

        let selectedImg = xmlFrame.state().get('selection').first().toJSON(); /* selectedImg.url */
        let lat = (($('#latitude').val().trim() != '' && $('#latitude').val() != 0) ? $('#latitude').val().trim() : 0.1),
          lng = (($('#longitude').val().trim() != '' && $('#longitude').val() != 0) ? $('#longitude').val().trim() : 0.1),
          anchorV = $('#marker_position').val().replace(/_/g, '-');
        if (selectedImg.subtype === 'svg+xml') {

          jQuery.ajax({
            type: 'GET',
            url: selectedImg.url,
            success: function(data) {
              let svgEle = document.createElement('div');
              svgEle.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
              let svgH = parseInt($(svgEle).find('svg').attr('height')),
                svgW = parseInt($(svgEle).find('svg').attr('width'));

              let iHeight = svgH <= 42 ? (svgH % 2 === 0 ? svgH : svgH + 1) : 42,
                iWidth = svgW <= 42 ? (svgW % 2 === 0 ? svgW : svgW + 1) : 42;

              let markerSizeR = Number.isNaN(parseInt($('#treweler-marker-img-size').val())) ? 42 : parseInt($('#treweler-marker-img-size').val());

              /* remove marker */
              marker.remove();
              /* add icon */
              var markerEle = document.createElement('div');
              markerEle.className = 'treweler-marker icon';
              markerEle.style.backgroundImage = 'url(' + selectedImg.url + ')';
              markerEle.style.backgroundSize = 'contain';
              markerEle.style.backgroundRepeat = 'no-repeat';
              markerEle.style.backgroundPosition = 'center center';
              markerEle.style.width = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : iWidth + 'px';
              markerEle.style.height = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : iHeight + 'px';

              marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
                draggable: true,
                anchor: anchorV
              }).setLngLat([lng, lat]).addTo(map);
              /**
               * Change marker position on drag
               */
              marker.on('dragend', function(e) {
                let ll = marker.getLngLat();
                $('#latitude').val(ll.lat);
                $('#longitude').val(ll.lng);
              });

              $('#marker_icon_size').val(iHeight + ';' + iWidth);

            }
          });

        } else {

          let iHeight = selectedImg.height <= 42 ? (selectedImg.height % 2 === 0 ? selectedImg.height : selectedImg.height + 1) : 42,
            iWidth = selectedImg.width <= 42 ? (selectedImg.width % 2 === 0 ? selectedImg.width : selectedImg.width + 1) : 42;

          let markerSizeR = Number.isNaN(parseInt($('#treweler-marker-img-size').val())) ? 42 : parseInt($('#treweler-marker-img-size').val());

          /* remove marker */
          marker.remove();
          /* add icon */
          var markerEle = document.createElement('div');
          markerEle.className = 'treweler-marker icon';
          markerEle.style.backgroundImage = 'url(' + selectedImg.url + ')';
          markerEle.style.backgroundSize = 'contain';
          markerEle.style.backgroundRepeat = 'no-repeat';
          markerEle.style.backgroundPosition = 'center center';
          markerEle.style.width = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : iWidth + 'px';
          markerEle.style.height = parseInt(markerSizeR) > 1 ? parseInt(markerSizeR) + 'px' : iHeight + 'px';

          marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
            draggable: true,
            anchor: anchorV
          }).setLngLat([lng, lat]).addTo(map);
          /**
           * Change marker position on drag
           */
          marker.on('dragend', function(e) {
            let ll = marker.getLngLat();
            $('#latitude').val(ll.lat);
            $('#longitude').val(ll.lng);
          });

          $('#marker_icon_size').val(iHeight + ';' + iWidth);
        }
      });
      $(document).on('twer-attach-remove', function(){
        addHTMLMarker();
        $('#marker_icon_size').val('');
      });

    }

    // Universal init color pickers
    $(document).on('click', '.js-twer-colorpicker .btn', function(event) {
      event.preventDefault();
      const $colorPicker = $(this);
      const $colorPickerCell = $colorPicker.children('.js-twer-colorpicker-cell');
      const $colorPickerWrap = $colorPicker.closest('.js-twer-colorpicker');
      const $palette = $colorPickerWrap.find('.js-twer-colorpicker-palette');
      const $colorInput = $colorPickerWrap.find('.js-twer-colorpicker-color');
      const $colorDefaultInput = $colorPickerWrap.find('.js-twer-colorpicker-custom-color');

      if ($palette.find('.a-color-picker').length === 0) {
        //console.log($colorInput.val());
        TWER_HELPERS.AColorPicker.from($palette[0], {
          showRGB : false,
          showHSL : false,
          paletteEditable : true,
          color : $colorInput.val()
        }).on('change', (picker, color) => {

          $colorPickerCell.css('background-color', picker.color);
          $colorInput.val(picker.color);
          $palette.attr('acp-color', picker.color);

          //console.log($colorInput.attr('id'));

          switch ($colorInput.attr('id')) {
            case 'markerColor' :
              $('.treweler-marker .marker .marker__border').css('border-color', picker.color);
              break;
            case 'marker_dotcenter_color' :
              $('.marker.marker--dot-solid').css('background-color', hex2rgba(picker.color, 1));
              break;
            case 'marker_halo_color' :
              let opacityHalo = $('#treweler-marker-halo-opacity').val();
              opacityHalo = Number.isNaN(parseFloat(opacityHalo)) ? 0.5 : parseFloat(opacityHalo);
              $('.treweler-marker .marker .marker__shadow').css('background-color', hex2rgba(picker.color, opacityHalo));
              break;
            case 'marker_border_color' :
              $('.treweler-marker .marker').css('border-color', hex2rgba(picker.color, 1));
              break;
            case 'marker_dot_color' :
              $('.treweler-marker.marker-balloon .marker-balloon__dot').css('background-color', hex2rgba(picker.color, 1));
              break;
            case 'marker_color_balloon' :
              $('.treweler-marker.marker-balloon').css('background-color', hex2rgba(picker.color, 1));
              break;
            case 'marker_border_color_balloon' :
              $('.treweler-marker.marker-balloon').css('border-color', hex2rgba(picker.color, 1));
              break;
            case 'marker_color_triangle' :
              $('.treweler-marker.marker-triangle').css('border-bottom-color', hex2rgba(picker.color, 1));
              break;
            case 'balloon_icon_color' :
              pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
              break;
            case 'dot_icon_color' :
              pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
              break;
          }

        }).on('coloradd', (picker, color) => {
          let cca = $colorDefaultInput;
          if (cca.val().indexOf('|' + color) === -1) {
            cca.val(cca.val() + '|' + color);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: cca.val()},
              success: function(response) {
                let defaultCP = $palette.attr('data-default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
                $palette.attr('acp-palette', defaultCP + '' + response);
                colorPicker.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        }).on('colorremove', (picker, color) => {
          let ccr = $colorDefaultInput;
          if (ccr.val().indexOf('|' + color) !== -1) {
            let sc = ccr.val().replace('|' + color, '');
            ccr.val(sc);
            jQuery.ajax({
              url: twer_ajax.url,
              type: 'POST',
              data: {action: 'treweler_add_colorpicker_custom_color', cust_color: ccr.val()},
              success: function(response) {
                let defaultCP = $palette.attr('data-default-palette');
                $palette.attr('acp-palette', defaultCP + '' + response);
              }
            });
          }
        });
      } else {
        $palette.find('.a-color-picker').remove();
      }

    });
    $('.js-twer-colorpicker-palette').on('click', function(event) {
      event.stopPropagation();
    });

    $('#treweler-marker-corner-radius-group-select').on('change', function() {
      let cornerRadiusUnitsSe1 = Number.isNaN(parseFloat($('#treweler-marker-corner-radius-group').val())) ? 50 : parseFloat($('#treweler-marker-corner-radius-group').val());
      const value = Number.isNaN(this.value) ? '%' : this.value;
      $('.treweler-marker .marker').css('borderRadius', `${cornerRadiusUnitsSe1}${value}`);
    });

    $([
      '#treweler-marker-halo-opacity',
      '#treweler-marker-size',
      '#treweler-marker-border-width',
      '#treweler-marker-corner-radius-group',
      '#treweler-marker-size-balloon',
      '#treweler-marker-border-width-balloon',
      '#treweler-marker-dot-size',
      '#treweler-marker-width-triangle',
      '#treweler-marker-height-triangle',
      '#treweler-balloon-icon-size',
      '#treweler-dot-icon-size'
    ].join()).on('keyup', function() {
      let value = $(this).val();
      const $marker = $('.treweler-marker .marker');
      switch (this.id) {
        case 'treweler-balloon-icon-size' :
          pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
          break;
        case 'treweler-dot-icon-size' :
          pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
          break;
        case 'treweler-marker-width-triangle' :
          value = Number.isNaN(parseFloat(value)) ? 12 : parseFloat(value);
          $('.treweler-marker.marker-triangle').css({
            borderRightWidth: `${value / 2}px`,
            borderLeftWidth: `${value / 2}px`,
          });
          break;
        case 'treweler-marker-height-triangle' :
          value = Number.isNaN(parseFloat(value)) ? 10 : parseFloat(value);
          $('.treweler-marker.marker-triangle').css({
            borderBottomWidth: `${value}px`,
          });
          break;
        case 'treweler-marker-size-balloon' :
          value = Number.isNaN(parseFloat(value)) ? 18 : parseFloat(value);
          $('.treweler-marker.marker-balloon').css({
            width: `${value}px`,
            height: `${value}px`,
          });
          const $marker1 = document.getElementsByClassName('marker-balloon')[0];
          const rotateHeight = $marker1.getBoundingClientRect().height;
          const rotateBorderWidthBalloon = Number.isNaN(parseFloat($('#treweler-marker-border-width-balloon').val())) ? 4 : parseFloat($('#treweler-marker-border-width-balloon').val());

          $('.treweler-marker.marker-balloon').css({
            bottom: ((rotateHeight - (value + rotateBorderWidthBalloon + rotateBorderWidthBalloon)) / 2)
          });
          break;
        case 'treweler-marker-border-width-balloon' :
          value = Number.isNaN(parseFloat(value)) ? 4 : parseFloat(value);
          $('.treweler-marker.marker-balloon').css({
            borderWidth: `${value}px`,

          });
          const $marker2 = document.getElementsByClassName('marker-balloon')[0];
          const rotateHeight2 = $marker2.getBoundingClientRect().height;
          const rotateBorderWidthBalloon2 = Number.isNaN(parseFloat($('#treweler-marker-size-balloon').val())) ? 18 : parseFloat($('#treweler-marker-size-balloon').val());

          $('.treweler-marker.marker-balloon').css({
            bottom: ((rotateHeight2 - (rotateBorderWidthBalloon2 + value + value)) / 2)
          });
          break;
        case 'treweler-marker-dot-size' :
          value = Number.isNaN(parseFloat(value)) ? 8 : parseFloat(value);

          $('.treweler-marker.marker-balloon .marker-balloon__dot').css({
            width: `${value}px`,
            height: `${value}px`,
            marginLeft: `${(value / 2) * -1}px`,
            marginTop: `${(value / 2) * -1}px`
          });
          break;
        case 'treweler-marker-halo-opacity' :
          value = Number.isNaN(parseFloat(value)) ? 0.5 : parseFloat(value);
          $('.treweler-marker .marker .marker__shadow').css('background-color', hex2rgba($('#marker_halo_color').val(), value));
          break;
        case 'treweler-marker-size' :
          value = Number.isNaN(parseFloat(value)) ? 12 : parseFloat(value);
          const realBrd = Number.isNaN(parseFloat($('#treweler-marker-border-width').val())) ? 0 : parseFloat($('#treweler-marker-border-width').val());

          $marker.css({
            width: `${value}px`,
            height: `${value}px`,
            marginLeft: `${((value + realBrd + realBrd) / 2) * -1}px`,
            marginTop: `${((value + realBrd + realBrd) / 2) * -1}px`
          });
          break;
        case 'treweler-marker-border-width' :
          value = Number.isNaN(parseFloat(value)) ? 0 : parseFloat(value);
          const realSize = Number.isNaN(parseFloat($('#treweler-marker-size').val())) ? 12 : parseFloat($('#treweler-marker-size').val());

          $marker.css({
            width: `${realSize}px`,
            height: `${realSize}px`,
            borderWidth: `${value}px`,
            marginLeft: `${((realSize + value + value) / 2) * -1}px`,
            marginTop: `${((realSize + value + value) / 2) * -1}px`
          });
          break;
        case 'treweler-marker-corner-radius-group' :
          value = Number.isNaN(parseFloat(value)) ? 50 : parseFloat(value);
          let cornerRadiusUnitsSe = Number.isNaN($('#treweler-marker-corner-radius-group-select').val()) ? '%' : $('#treweler-marker-corner-radius-group-select').val();
          $marker.css('borderRadius', `${value}${cornerRadiusUnitsSe}`);
          break;
      }

    });

    /* $(document).on('click', function() {
     $('.js-twer-colorpicker-palette').find('.a-color-picker').remove();
     });
     */
    $(document).on('click', function(event) {
       /*if (!$(event.target).hasClass('a-color-picker')
       && $(event.target).parents('.a-color-picker').length === 0
       && !$(event.target).hasClass('js-twer-colorpicker-cell')
       && !$(event.target).hasClass('a-color-picker-palette-color')) {
       colorPicker.find('.a-color-picker').remove();
       }*/

      if (!$(event.target).closest('.js-twer-colorpicker').length > 0) {
        $('.js-twer-colorpicker-palette').find('.a-color-picker').remove();
      }
    });

    $(document).on('change', '#marker_position, #treweler-marker-img-size', function() {
      let imgObj = $('#thumbnail_id').closest('.js-twer-attach-wrap').find('img').attr('src');
      if (imgObj.length !== undefined && imgObj.length > 0) {

        let lat = (($('#latitude').val().trim() !== '' && $('#latitude').val() !== 0) ? $('#latitude').val().trim() : 0.1),
          lng = (($('#longitude').val().trim() !== '' && $('#longitude').val() !== 0) ? $('#longitude').val().trim() : 0.1),
          imgURL = $('#thumbnail_id').closest('.js-twer-attach-wrap').find('img').attr('src'),
          anchorV = $('#marker_position').val().replace(/_/g, '-'),
          markerImgSize = Number.isNaN(parseInt($('#treweler-marker-img-size').val())) ? 42 : parseInt($('#treweler-marker-img-size').val()),
          imgSize = $('#marker_icon_size').val() !== '' ? $('#marker_icon_size').val().split(';') : '42;42'.split(';');

        let iHeight = parseInt(imgSize[0]) <= 42 ? (parseInt(imgSize[0]) % 2 === 0 ? parseInt(imgSize[0]) : parseInt(imgSize[0]) + 1) : 42;
        let iWidth = parseInt(imgSize[1]) <= 42 ? (parseInt(imgSize[1]) % 2 === 0 ? parseInt(imgSize[1]) : parseInt(imgSize[1]) + 1) : 42;


        /* remove marker */
        marker.remove();

        /* Add Marker */
        var markerEle = document.createElement('div');
        markerEle.className = 'treweler-marker icon';
        markerEle.style.backgroundImage = 'url(' + imgURL + ')';
        markerEle.style.backgroundSize = 'contain';
        markerEle.style.backgroundRepeat = 'no-repeat';
        markerEle.style.backgroundPosition = 'center center';
        markerEle.style.width = parseInt(markerImgSize) > 1 ? parseInt(markerImgSize) + 'px' : parseInt(iWidth) + 'px';
        markerEle.style.height = parseInt(markerImgSize) > 1 ? parseInt(markerImgSize) + 'px' : parseInt(iHeight) + 'px';
        /*	markerEle.style.imageRendering = '-webkit-optimize-contrast'; */
        marker = new TWER_MAPBOX.mapboxgl.Marker(markerEle, {
          draggable: true,
          anchor: anchorV
        }).setLngLat([lng, lat]).addTo(map);

        /**
         * Change marker position on drag
         */
        marker.on('dragend', function(e) {
          let ll = marker.getLngLat();
          $('#latitude').val(ll.lat);
          $('#longitude').val(ll.lng);
        });

      }
    });

    const $picker = jQuery('.js-twer-iconpicker').fontIconPicker({
      iconGenerator: function(icon) {
        return '<i class="material-icons">' + icon + '</i>';
      }
    }).on('change', function() {
      pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
    }).on('open', function() {

    });
    const xhr = new XMLHttpRequest();

    xhr.open('GET', twer_ajax.fonts_url + 'material-icons.json');
    xhr.send();

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const icons = xhr.response;

        if (icons) {
          $picker.setIcons(JSON.parse(icons));

        }
      } else {
        console.log(`Error: ${xhr.status}: ${xhr.statusText}`);
      }
    };

    xhr.onerror = () => console.log(xhr.statusText);













    $('#twer-nav-custom-fields .table tbody').each((index, element) => {
      const $sortableList = $(element);
      $sortableList.sortable({
        cursor: 'move',
        placeholder: 'ui-sortable-placeholder twer-tr-toggle js-ui-slider-item',
        forcePlaceholderSize: true,
        forceHelperSize: true,
        scroll: true,
        revert: false,
        tolerance: 'pointer',
        handle: '.js-twer-ui-sort-tr',
        items: '> .js-ui-slider-item',
        create : function() {
          const $input = $sortableList.find('input.js-twer-custom-fields-list');
          let ids = [];
          $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
            ids.push($(div).data('id'));
          });
          //console.log(ids);
          $input.val(ids.join(','));
        },
        update: function(event, ui) {
          const $input = $sortableList.find('input.js-twer-custom-fields-list');
          let ids = [];
          $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
            ids.push($(div).data('id'));
          });
          //console.log(ids);
          $input.val(ids.join(','));
        }
      }).disableSelection();
    });


    $(document).on('click', '.js-twer-ui-del-tr', function(e) {
      e.preventDefault();
      const $sortableList = $(this).closest('tbody');
      const $input = $sortableList.find('input.js-twer-custom-fields-list');
      const $select = $sortableList.find('#treweler-custom-field-add');
      const ids = [];
      const id = $(this).closest('.js-ui-slider-item').data('id');
      const label = $(this).closest('.js-ui-slider-item').find('th label').text();
      $select.append('<option value="'+id+'">'+label+'</option>');


      $(this).closest('.js-ui-slider-item').remove();
      $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
        ids.push($(div).data('id'));
      });
      $input.val(ids.join(','));
    });


    $(document).on('click', '.js-add-custom-field', function(e){
      e.preventDefault();

      const $select = $('#treweler-custom-field-add');
      const selectedId = $select.val();
      if('none' !== selectedId) {
        const $row = $('.js-hidden-item[data-id="' + selectedId + '"]').clone();
        const ids = [];
        $row.toggleClass('d-none js-ui-slider-item');
        $row.removeClass('js-hidden-item');


        $row.insertBefore('.js-hidden-item:first');
        $select.find('option:selected').remove();
        const $sortableList = $(this).closest('tbody');
        const $input = $sortableList.find('input.js-twer-custom-fields-list');
        $sortableList.sortable('refresh');
        $sortableList.sortable('refreshPositions');
        $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
          ids.push($(div).data('id'));
        });
        $input.val(ids.join(','));
      }
    });




  });
})(jQuery);

(function() {

  window.addEventListener('DOMContentLoaded', () => {

    const toggleElements = () => {
      const $toggleElements = document.getElementsByClassName('js-toggle-row');

      if ($toggleElements.length > 0) {
        for (let i = 0; i < $toggleElements.length; i++) {
          const $element = $toggleElements[i];

          let relatedVal = $element.dataset.relatedVal;
          const relatedId = $element.dataset.relatedId;

          let relatedType = undefined;
          if (relatedVal === '1' || relatedVal === '0') {
            relatedType = 'checkbox';
            relatedVal = '1' === relatedVal;
          } else {
            relatedType = 'select';
            relatedVal = relatedVal.split(',');
          }


          const $elementRelated = document.getElementById(relatedId);
          const elementRelatedVal = $elementRelated.value;

          if ($elementRelated.closest('.twer-tr-toggle').classList.contains('d-none')) {
            $element.classList.add('d-none');
          } else {
            if (relatedType === 'select') {
              if (relatedVal.includes(elementRelatedVal)) {
                $element.classList.remove('d-none');
              } else {
                $element.classList.add('d-none');
              }
            } else if (relatedType === 'checkbox') {
              if (relatedVal === $elementRelated.checked) {
                $element.classList.remove('d-none');
              } else {
                $element.classList.add('d-none');
              }
            }
          }
        }
      }
    };

    toggleElements();

    document.getElementById('marker_style').onchange = function() {
      toggleElements();
    };
    document.getElementById('treweler-picker').onchange = function() {
      toggleElements();
      pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
    };
    document.getElementById('treweler-picker-dot').onchange = function() {
      toggleElements();
      pickerMapApply(['treweler-picker', 'treweler-picker-dot'], ['treweler-balloon-icon-picker', 'treweler-dot-icon-picker'], ['balloon_icon_color', 'dot_icon_color'], ['treweler-balloon-icon-size', 'treweler-dot-icon-size']);
    };
    document.getElementById('treweler-label-has-bg').onchange = function() {
      toggleElements();
    };
  });

  window.addEventListener('load', () => {

  });

})();
